import React, { useRef, useState } from "react";
import { Button, Modal, Table } from "antd";
import helpImg from "../../../images/K-ICT03_04_help.png";
import usePortal from "react-useportal";
import { getLastDomByClassName } from "../../../utils";
import { Title } from "./Common";
import "antd/dist/antd.css";
import "ant-design-draggable-modal/dist/index.css";
import { TI_SHOW_LIST_BUTTON } from "../../../Constants";
import { StyledButton } from "../../../styled-components/Button";

const WidgetHelp = () => {
  const { Column } = Table;
  const [visible, setVisible] = useState(false);
  const dataSource = [
    {
      key: "1",
      kind: "통제국",
      communication: "제1통신 : VHF\n" + "제2통신 : CDMA",
      roll: "우량국 또는 수위국의 신호를 받아 서버내 LOG에 저장하고 경보국으로 신호를 전달합니다.",
      etc:
        "강우량 호출\n" +
        "경보 명령\n" +
        "장비 상태 감시\n" +
        "우량 경보상화 기록\n" +
        "감시국 상황 전송",
    },
    {
      key: "2",
      kind: "우량국",
      communication: "VHF, CDMA",
      roll: "강수량센서를 이용, 해당지역의 강우(강수)량을 감지, 정량화시켜 처리 장치에 저장되며, 저장되어 있는 DATA는 각종 통신망(VHF, CDMA)을 이용 중앙 센터로 수집 되어 홍수 예경보 및 재난 예경보등의 업무를 수행합니다.",
      etc:
        "강우량 측정\n" + "강우량 저장\n" + "강우량 전송\n" + "장비 상태 전송",
    },
    {
      key: "3",
      kind: "수위국",
      communication: "VHF, CDMA",
      roll: "하천의 교각 혹은 하천변 및 산간계곡이나 기타지역에 설치되어 수위센서를 통해 수위값을 측정하고 수위치가 최대한계값이 넘을시 통제국으로 신호를 송신합니다.",
      etc: "수위 측정\n" + "수위 저장\n" + "수위 전송\n" + "장비 상태 전송",
    },
    {
      key: "4",
      kind: "경보국",
      communication: "VHF, CDMA",
      roll: "32BIT 산업용 프로세서를 이용하여 경보국 기능을 수행하며, 통제국으로부터 받은 신호를 내부에 녹음되어 있는 메시지를 안내방송하거나 음성으로 직접 경보메시지를 방송 할 수 있습니다.",
      etc: "경보 발송\n" + "경보 상태 전송\n" + "장비 상태 전송",
    },
    {
      key: "5",
      kind: "중계국",
      communication: "VHF, CDMA",
      roll: "통제국과 우량국, 경보국, 수위국간의 무선통신을 중계합니다.",
      etc: "",
    },
  ];

  const columns = [
    {
      title: "구분",
      dataIndex: "kind",
      key: "kind",
      width: 30,
    },
    {
      title: "통신방식",
      dataIndex: "communication",
      key: "communication",
      width: 60,
    },
    {
      title: "역할",
      dataIndex: "roll",
      key: "roll",
      width: 180,
    },
    {
      title: "비고",
      dataIndex: "etc",
      key: "etc",
      width: 70,
    },
  ];
  const { Portal } = usePortal({
    bindTo: getLastDomByClassName("toolbar-show-help"),
  });

  const helpButtonRef = useRef(null);

  return (
    <>
      <Portal>
        <StyledButton
          isActive={visible}
          onClick={() => setVisible((visible) => !visible)}
          tabIndex={TI_SHOW_LIST_BUTTON + 1}
          ref={helpButtonRef}
        >
          도움말
        </StyledButton>
      </Portal>
      <Modal
        style={{ zIndex: 11 }}
        centered
        width={770}
        closable={false}
        bodyStyle={{ padding: 30, height: 500, overflowY: "scroll" }}
        visible={visible}
        getContainer={false}
        mask={false}
        footer={null}
        title={
          <Title
            children={"우량경보 무선국"}
            extra={
              <StyledButton
                onClick={() => {
                  setVisible((visible) => !visible);
                  setTimeout(() => {
                    if (helpButtonRef.current) {
                      helpButtonRef.current.focus();
                    }
                  }, 300);
                }}
              >
                닫기
              </StyledButton>
            }
          />
        }
      >
        <div>
          <div>
            <p>
              태풍, 집중호우, 기상이변등 긴급 자연재해 발생시 재해 상황을 신속,
              정확하게 파악하여 전파를 통해
              <br />
              상황을 알리고 대처하여 산간계곡 및 저지대 국민들의 인명안전 및
              재산보호에 목적을 두는 시스템입니다.
            </p>
            <hr />
            <h3>우량경보 시스템 구성도</h3>
            <div>
              <img src={helpImg} alt="우량경보 시스템 구성도" />
            </div>
            <hr />
            <h3>우량경보시스템 구성</h3>
            <p>구분, 통신방식, 역할, 비고로 구성된 표</p>

            <Table
              dataSource={dataSource}
              size={"small"}
              bordered={true}
              pagination={false}
            >
              {columns.map(({ title, key, dataIndex, width }) => (
                <Column
                  title={title}
                  dataIndex={dataIndex}
                  key={key}
                  width={width}
                  render={(key) =>
                    key.split("\n").map((line) => {
                      return (
                        <span>
                          {line}
                          <br />
                        </span>
                      );
                    })
                  }
                />
              ))}
            </Table>

            <hr />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default WidgetHelp;
